import { render, staticRenderFns } from "./SearchSort.vue?vue&type=template&id=eb6547d6&"
import script from "./SearchSort.vue?vue&type=script&lang=ts&"
export * from "./SearchSort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports